export default {"src":"/_next/static/media/OAuthSDKDark.9a901c70.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};